import { WidgetPlatformEnum } from './widget-platform.enum';
import { AnalyticUserActivityModel } from './analytic-activity.model';

export class UserAnalyticModel {
    analytic_platform: WidgetPlatformEnum;
    analytic_type: string;
    // analytic_id: string;
    // analytic_app_name: string;
    // analytic_description: string;

    analytic_data: AnalyticUserActivityModel;
}
